import { jsxs as _jsxs } from "react/jsx-runtime";
import "antd/lib/tooltip/style";
import _Tooltip from "antd/lib/tooltip";
import _defineProperty from "/var/www/vhosts/voicebrief.app/httpdocs/next/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { jsx as _jsx } from "react/jsx-runtime";
import _regeneratorRuntime from "/var/www/vhosts/voicebrief.app/httpdocs/next/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/www/vhosts/voicebrief.app/httpdocs/next/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "antd/lib/upload/style";
import _Upload from "antd/lib/upload";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { CameraFilled, LoadingOutlined } from '@ant-design/icons';
import React, { useState, useEffect, useMemo } from 'react';
import ServiceBriefs from 'services/ServiceBriefs';
import ImgCrop from 'antd-img-crop';
import 'antd/es/modal/style';
import 'antd/es/slider/style';
var Dragger = _Upload.Dragger;

var UploadImage = function UploadImage(_ref) {
  var onUpload = _ref.onUpload,
      uploadedImage = _ref.uploadImage,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'box' : _ref$type,
      className = _ref.className,
      _ref$showImage = _ref.showImage,
      showImage = _ref$showImage === void 0 ? true : _ref$showImage,
      _ref$enableCrop = _ref.enableCrop,
      enableCrop = _ref$enableCrop === void 0 ? false : _ref$enableCrop,
      _ref$aspect = _ref.aspect,
      aspect = _ref$aspect === void 0 ? 100 / 30 : _ref$aspect;

  //uploading
  var _useState = useState(false),
      uploading = _useState[0],
      setUploading = _useState[1];

  var _useState2 = useState(false),
      uploaded = _useState2[0],
      setUploaded = _useState2[1];

  var hasImage = useMemo(function () {
    if (uploaded) return true;
    if (!uploadedImage) return false;else {
      return true;
    }
  }, [uploadedImage]);
  useEffect(function () {
    var _document$body, _document$body2;

    (_document$body = document.body) === null || _document$body === void 0 ? void 0 : _document$body.addEventListener('dragover', function (ev) {
      ev.preventDefault();
    });
    (_document$body2 = document.body) === null || _document$body2 === void 0 ? void 0 : _document$body2.addEventListener('drop', function (ev) {
      ev.preventDefault();
    });
    return function () {
      var _document$body3, _document$body4;

      (_document$body3 = document.body) === null || _document$body3 === void 0 ? void 0 : _document$body3.removeEventListener('dragover', function (ev) {
        ev.preventDefault();
      });
      (_document$body4 = document.body) === null || _document$body4 === void 0 ? void 0 : _document$body4.removeEventListener('drop', function (ev) {
        ev.preventDefault();
      });
    };
  }, []);
  var UploadPros = {
    name: 'fileToUpload',
    multiple: false,
    showUploadList: false,
    //listType: "picture-card",
    //    iconRender: () => "picture",
    onChange: function onChange(info) {
      var status = info.file.status;

      if (status !== 'uploading') {
        console.log(info.file, info.fileList);
      }

      if (status === 'done') {
        console.info("".concat(info.file.name, " file uploaded successfully."));
      } else if (status === 'error') {
        console.error("".concat(info.file.name, " file upload failed."));
      }
    },
    accept: 'image/jpeg,image/jpg,image/png',
    onRemove: function onRemove(file) {
      setUploading(false);
    },
    customRequest: function () {
      var _customRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
        var file, onSuccess, onError, onProgress, theFile;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                file = _ref2.file, onSuccess = _ref2.onSuccess, onError = _ref2.onError, onProgress = _ref2.onProgress;
                theFile = file; //@ts-ignore

                if (enableCrop) file = new File([file], theFile.name, {
                  lastModified: 1534584790000,
                  type: theFile.type
                }); // const onProgr = ({ total, loaded }) => {
                //   console.log({ total, loaded })
                //   onProgress({ percent: Math.round(loaded / total * 100) } )
                // }

                setUploading(true); //debugger;

                ServiceBriefs.upload({
                  file: file,
                  onProgress: onProgress
                }).then(function (image) {
                  if (image.imageUrl) {
                    onUpload && onUpload(image.imageUrl);
                    setUploaded(image.imageUrl);
                  }
                })["catch"](onError)["finally"](function () {
                  return setUploading(false);
                });

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function customRequest(_x) {
        return _customRequest.apply(this, arguments);
      }

      return customRequest;
    }(),
    onPreview: function () {
      var _onPreview = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(file) {
        var src, image, imgWindow;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (enableCrop) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return", file);

              case 2:
                src = file.url;

                if (src) {
                  _context2.next = 7;
                  break;
                }

                _context2.next = 6;
                return new Promise(function (resolve) {
                  var reader = new FileReader(); //@ts-ignore

                  reader.readAsDataURL(file.originFileObj);

                  reader.onload = function () {
                    return resolve(reader.result);
                  };
                });

              case 6:
                src = _context2.sent;

              case 7:
                image = new Image(); //@ts-ignore

                image.src = src;
                imgWindow = window.open(src); //debugger;
                //@ts-ignore

                imgWindow.document.write(image.outerHTML);

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function onPreview(_x2) {
        return _onPreview.apply(this, arguments);
      }

      return onPreview;
    }()
  };
  return /*#__PURE__*/_jsx("div", {
    className: "clearfix\n          UploadImage \n          ".concat(className, "\n          ").concat(showImage ? 'showImage' : '', "\n          ").concat(hasImage ? 'hasImage' : 'noImage', "\n          ").concat(type == 'circle' ? 'circle' : '', "\n        "),
    style: {
      backgroundImage: showImage ? "url(".concat(uploadedImage || uploaded, ")") : ''
    },
    children: /*#__PURE__*/_jsx(_Tooltip, {
      title: "click or drag to upload image",
      children: /*#__PURE__*/_jsx("div", {
        className: "uploadDrag relative  ",
        children: enableCrop ? /*#__PURE__*/_jsx(ImgCrop, {
          shape: "rect",
          zoom: true,
          rotate: true,
          grid: true,
          aspect: aspect,
          modalOk: "Save",
          children: /*#__PURE__*/_jsx(Dragger, _objectSpread(_objectSpread({}, UploadPros), {}, {
            children: /*#__PURE__*/_jsx("p", {
              className: "ant-upload-drag-icon",
              children: uploading ? /*#__PURE__*/_jsx(LoadingOutlined, {}) : /*#__PURE__*/_jsx(CameraFilled, {})
            })
          }))
        }) : /*#__PURE__*/_jsx(Dragger, _objectSpread(_objectSpread({}, UploadPros), {}, {
          children: /*#__PURE__*/_jsx("p", {
            className: "ant-upload-drag-icon",
            children: uploading ? /*#__PURE__*/_jsx(LoadingOutlined, {}) : /*#__PURE__*/_jsx(CameraFilled, {})
          })
        }))
      })
    })
  });
};

var UploadButton = /*#__PURE__*/_jsxs("div", {
  children: [/*#__PURE__*/_jsx(CameraFilled, {}), /*#__PURE__*/_jsx("div", {
    className: "ant-upload-text",
    children: "Upload"
  })]
});

export default UploadImage;